export default "__VITE_ASSET__CSpNrn3o__"